import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList} from 'angularfire2/database';
import * as firebase from 'firebase/app';
@Injectable()
export class FinanceService {
    financeExpenseCat : AngularFireList<any>;
    dependentColumn: any;
    secondvalue: any;
  constructor(private firebase : AngularFireDatabase) {

   }
   CategoryNamePicklist:any;

// Generic

find(value,field,from) {
    return firebase.database().ref(from).orderByChild(field).equalTo(value);
}

checkDependency(dependentdb,dependentColumnName,dependentValue) {
    return firebase.database().ref(dependentdb).orderByChild(dependentColumnName).equalTo(dependentValue);
}

// Category

addfinanceExpenseCat(Category,key) {
    return firebase.database().ref('financeExpenseCat').child(key).set(Category);
    //return this.firebase.list('financeExpenseCat').push(Category);
}
updateFinanceExpenseCat(Category)
{
    return firebase.database().ref('financeExpenseCat').child(Category.id).update(Category);
}
getAllFinanceExpenseCat() {
    return this.firebase.list('financeExpenseCat');
}

getFinanceExpenseCat(id) {
    var rootRef = firebase.database().ref('financeExpenseCat');
    return rootRef.child(id);
}

updateFinanceExpenseCatAmount(id,amount) {
    firebase.database().ref("financeExpenseCat/"+id).update({ amount: amount });
}

deleteCat(id)
{
    return firebase.database().ref('financeExpenseCat').child(id).remove();
}

// Category Type

getAllFinanceExpenseCatType() {
    return this.firebase.list('financeExpenseCatType');
}

addfinanceExpenseCatType(CategoryType) {
    return this.firebase.list('financeExpenseCatType').push(CategoryType);
}

updateFinanceExpenseCatType(CategoryType)
{
    return firebase.database().ref('financeExpenseCatType').child(CategoryType.id).update(CategoryType);
}

getFinanceExpenseCatType(id) {
    var rootRef = firebase.database().ref('financeExpenseCatType');
    return rootRef.child(id);
}

deleteCatType(id)
{
    return firebase.database().ref('financeExpenseCatType').child(id).remove();
}

// VAT

getVat() {
    return this.firebase.list('vat');
}

submitVat(vatForm) {
    return firebase.database().ref('vat').child(vatForm.id).update(vatForm);
}

// Finance Transactions

addFinanceTransaction(key,transactionForm) {
    return firebase.database().ref('financeTransactions').child(key).set(transactionForm);
    //return this.firebase.list('financeTransactions').push(transactionForm);
}

updateFinanceTransaction(Transaction)
{
    return firebase.database().ref('financeTransactions').child(Transaction.id).update(Transaction);
}

getAllTransactionList() {
    return this.firebase.list('financeTransactions');
}

getFinanceTransaction(id) {
    var rootRef = firebase.database().ref('financeTransactions');
    return rootRef.child(id);
}

deleteFinanceTransaction(id) {
    return firebase.database().ref('financeTransactions').child(id).remove();
}

filter(from,to,dbName,columnName) {
    var query = firebase.database().ref().child(dbName).orderByChild(columnName).startAt(from).endAt(to);
    return query.once('value')
        .then(function (snaps) {
            return snaps;
        });
}

// Profit/Loss Screen & Finance Overview

getAllTransactionListByYear() {
    var date = new Date();
    var year = date.getFullYear();
    var startDate = year + "/01/01";
    var endDate = year + "/12/31";
    var query = firebase.database().ref().child('financeTransactions').orderByChild('dateTimestamp').startAt(startDate).endAt(endDate);
    return query.once('value')
        .then(function (snaps) {
            return snaps;
        });
}

getAllEmployeeSalary() {
    var date = new Date();
    var year = String(date.getFullYear());
    var query = firebase.database().ref('employeeSalaries').child(year);
    return query.once('value')
        .then(function (snaps) {
            return snaps;
        });
}

getSalesList() {
    var date = new Date();
    var year = String(date.getFullYear());
    var startID = year+"00000000";
    var endID = year+"99999999";
    var query = firebase.database().ref("shipments").orderByKey().startAt(startID).endAt(endID);
    return query.once('value')
    .then(function (snaps) {
        return snaps;
    });
}

//Account Type Screen in settings

getAllFinanceAccountType() {
    return this.firebase.list('financeAccountType');
}

addFinanceAccountType(AccountType) {
    return this.firebase.list('financeAccountType').push(AccountType);
}

updateFinanceAccountType(AccountType)
{
    return firebase.database().ref('financeAccountType').child(AccountType.id).update(AccountType);
}

getFinanceAccountType(id) {
    var rootRef = firebase.database().ref('financeAccountType');
    return rootRef.child(id);
}

deleteFinanceAccountType(id)
{
    return firebase.database().ref('financeAccountType').child(id).remove();
}

// Accounts 

getAllFinanceAccounts() {
    return this.firebase.list('financeAccounts');
}

addFinanceAccounts(Account,key) {
    //return this.firebase.list('financeAccounts').push(Account);
    return firebase.database().ref('financeAccounts').child(key).set(Account);
}

updateFinanceAccounts(Account)
{
    return firebase.database().ref('financeAccounts').child(Account.id).update(Account);
}

getFinanceAccounts(id) {
    var rootRef = firebase.database().ref('financeAccounts');
    return rootRef.child(id);
}

deleteFinanceAccounts(id)
{
    return firebase.database().ref('financeAccounts').child(id).remove();
}

//Fund Transfers

getNextKey(db,child) {
   return firebase.database().ref(db).push();
}

getAllUsers() {
    return this.firebase.list('users');
}

getAllFundTransfers() {
    return this.firebase.list('fundTransfers');
}

updateAccounts(fromKey,newFromAmount,toKey,newToAmount) {
    firebase.database().ref("financeAccounts/"+fromKey).update({ accAmount: newFromAmount });
    return firebase.database().ref("financeAccounts/"+toKey).update({ accAmount: newToAmount });
}
addTransferFunds(transferForm) {
     return this.firebase.list('fundTransfers').push(transferForm);
}



}


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/finance-management/shared/finance.service.ts